import React from 'react';
import httpservice from '../../_service/httpservice';
import SearchFilter from './filter.component';
import List from './list';
import SearchInput from './SearchInput';
import { useParams } from "react-router-dom";
import BreadCrumb from './breadCrumb';
import SubDepartments from './subDepartment';
const limit = 12;
const SearchList = () => {
    const params: any = useParams();
    const [parent, setParent] = React.useState<any>(null);
    const [mainParent, setMainParent] = React.useState<boolean>(false);
    const [child, setChild] = React.useState<any>(null);
    const [isFilter, setIsFilter] = React.useState<boolean>(((window as any).isFilterByShow as boolean) ?? true);
    const [listData, setListData] = React.useState<any>(null);
    const [parentDeps, setParentDeps] = React.useState<any>(null);
    const [dep, setDep] = React.useState<any>(null);
    const [totalCount, setTotalcount] = React.useState<any>(-1);
    const [searchParam, setSearchParam] = React.useState({
        query: '',
        department: ''
    });
    React.useEffect(() => {
        let win = (window as any);
        if (params) {
            setParent(params?.parent || '')
            setChild(params?.child || '')
            getDep(win.currentDep);
            getParentDep(win.currentDep);
            if (win.mainParent)
            setMainParent(win.mainParent)
        }
    }, [params])
    const [activePage, setActivePage] = React.useState(0);
    const [pages, setPages] = React.useState(0);
    const _calculatePagesCount = (pageSize: number, totalCount: number) => {
        return totalCount < pageSize ? 1 : Math.ceil(totalCount / pageSize);
    }
    const getListData = async (pageNumber: number, param: any, isLoadMore: boolean) => {
        const win = window as any;
        const url = win.itemUrl;
        const currentDep = win.currentDep;
        param.currentDep = currentDep;
        param.isFilterMenu = isFilter;
        const header = {
            page: pageNumber,
            limit: limit,
        }
        const res = await httpservice.action.get(url, param, header);
        if (isLoadMore) {
            setListData([...listData, ...res?.data?.data])
        } else {
            const data = res?.data?.data;
            const totalPages = _calculatePagesCount(limit, res.data.totalCount);
            setPages(totalPages);
            setListData(data)
            setTotalcount(res.data.totalCount)
        }
    }
    const getDep = async (id: string) => {
        const res = await httpservice.action.get(`/Global/dep/${id}`);
        setDep(res?.data);
    }
    const getParentDep = async (id: string) => {
        const res = await httpservice.action.get(`/Global/dep/parent/${id}`);
        setParentDeps(res?.data);
    }
        
    React.useEffect(() => {
        let win = (window as any);
        let payload = {
            ...searchParam,
            query: win.query
        }
        setSearchParam(payload);
        if(!mainParent)
        getListData(0, payload, false)
      
    }, []);
    const handleLoadMore = () => {
        setActivePage(activePage + 1);
        getListData(activePage + 1, searchParam, true)
    };
    const handleSearch = (value: string) => {
        let payload = {
            ...searchParam,
            query: value
        }
        setSearchParam(payload)
        setActivePage(0);
        getListData(0, payload, false)
    }
    const addOrRemove = (value: string) => {
        let win = window as any;
        let array = win.depId as string[];
        var index = array.indexOf(value);

        if (index === -1) {
            array.push(value);
        } else {
            array.splice(index, 1);
        }
        return array;
    }
    const handleFilter = (departmentID: string) => {
        var deps = addOrRemove(departmentID);
        let payload = {
            ...searchParam,
            department: deps.toString()
        }
        setSearchParam(payload)
        setActivePage(0);
        getListData(0, payload, false)
    }
    const handleAllFilter = () => {
        let win = window as any;
        win.depId = [];
        let payload = {
            ...searchParam
        }
        setSearchParam(payload)
        setActivePage(0);
        getListData(0, payload, false)
    }
    return (
        <section className="listing-section">
            <div className="container">
                <div className="row">
                    {isFilter ?  (
                        mainParent ? "":(<div className="col-lg-3 col-sm-12 bg-white">
                            <SearchFilter handleFilter={handleFilter} currentDep={dep} handleAllFilter={handleAllFilter} parent={parent} />
                        </div>)) : ""}
                    <div className={mainParent ? "col-lg-12 position-relative" : (isFilter ? "col-lg-9 position-relative" : "col-lg-12 position-relative")}>
                        { mainParent ? "": ( <>
                            <div className="product-title">
                                <BreadCrumb parentDeps={parentDeps} name={dep?.name} />
                                <SearchInput emitHandleSearch={handleSearch} />
                            </div>
                        </>)}
                        {dep?.photo &&
                            <div className="art-image">
                                <img src={dep?.photo} alt={dep?.name} />
                            </div>
                        }
                        {<SubDepartments childDeps={dep?.childrens} />}

                        {mainParent ? "":
                            (<div className="product-count">
                                <p>Showing <span className="bold-text">{` ${totalCount | 0} ${(totalCount | 0) <= 1 ? 'product' :'products'}`}</span> in {dep?.name} </p>
                            </div>)
                        }
                        {
                            mainParent ? "": (totalCount && (totalCount == -1 || totalCount > 0) ?
                                <List handleLoadMore={handleLoadMore} listData={listData} totalCount={totalCount} pages={pages} activePage={activePage} />
                                : <div className="noitemfound">No Items found</div>)
                        }
                        
                    </div>
                </div>
                {/*<SubScriptionSection />*/}
            </div>
        </section>
    );
}
export default SearchList;
